import ShoppingCenter from './main';
import ShoppingCenterEdit from './edit';
import SingleShop from './singleShop';

const routes = [
    {
        path: '/*',
        Component: ShoppingCenter,
        props: {},
    },
    {
        path: '/:id/edit',
        Component: ShoppingCenterEdit,
        props: {},
    },
    {
        path: '/:id',
        Component: SingleShop,
        props: {},
    },
    {
        path: '/new',
        Component: ShoppingCenterEdit,
        props: {
            isNew: true,
        },
    },
];

export default routes;
